import React from 'react';

export interface ItemCollectionProps {
  columns?: number,
  tablet?: boolean,
  wide?: boolean,
  block?: boolean,
  headlineContent?: string
}

const ItemCollection: React.FC<ItemCollectionProps> = ({
  columns,
  tablet,
  wide,
  block,
  headlineContent,
  children,
}) => {
  const additionalStyleClasses: string[] = [];

  if (columns) {
    additionalStyleClasses.push(`item-collection-${columns}-columns`);
  }

  if (tablet) {
    additionalStyleClasses.push('item-collection-tablet');
  }

  if (wide) {
    additionalStyleClasses.push('item-collection-wide');
  }

  if (block) {
    additionalStyleClasses.push('item-collection-block');
  }

  return (
    <div className={`item-collection ${additionalStyleClasses.join(' ')}`}>
      {headlineContent
        && (
          <div className="headline">
            <h3 dangerouslySetInnerHTML={{ __html: headlineContent }} />
          </div>
        )}
      <div className="items">
        {children}
      </div>
    </div>
  );
};

export default ItemCollection;
